import { LitElement, html, svg } from 'lit';

export class IconBatteryEmpty24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Tomt batteri</title><rect width="19" height="12" x="4" y="6" stroke="currentColor" stroke-width="1.5" rx="2"></rect><path stroke="currentColor" stroke-width="1.5" d="M4 9H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2"></path><path fill="currentColor" d="M19.75 9a.75.75 0 0 0-1.5 0h1.5Zm-1.5 6a.75.75 0 0 0 1.5 0h-1.5Zm1.5 0V9h-1.5v6h1.5Z"></path></svg>`; }
}
if (!customElements.get('f-icon-battery-empty24', IconBatteryEmpty24)) {
  customElements.define('f-icon-battery-empty24', IconBatteryEmpty24);
}